import { HashRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/LandingPage";
import Dashboard from "./pages/Dashboard";

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/dash/*" element={<Dashboard />} />
      </Routes>
    </HashRouter>
  );
}

export default App;